/* eslint-disable key-spacing */
import pitches from '../dominoes/pitches'

export default {
    className: 'facesPitch',
    styles: pitches,
}
